import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  profile: [],
  error: null,
  loader: false,
}

export const profileSlice = createSlice({
  name: 'profile',
  initialState: initialState,
  reducers: {
    setProfile: (state, { payload }) => {
      state.profile = payload?.data ?? payload;
    },
    setProfiles: (state, { payload }) => {
      state.profile = payload?.data;
    },
    removeProfile: (state, { payload }) => {
      state.error = payload
    },
    clearAllProfile: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})


export const updateProfile = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateProfile(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setProfile(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const changePassword = (data, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
  
      const json = await Api.changePassword(data)
      if (json.status >= 200 && json.status < 300) {
        callback(true, json.data.message)
      } else if (json.status == 422) {
        dispatch(setError(json.data))
        callback(false, json.data.message)
      }
    } catch (error) {
      console.log(error)
      // callback(false)
  
    }
    dispatch(setLoader(false))
  }



export const { setProfile, setProfiles, clearAllProfile, setLoader, setError, setMoreProfiles } = profileSlice.actions


export default profileSlice.reducer
export const profileSelector = state => state.profile


